import React, { PureComponent } from "react";
import { Wrapper, Copy } from "app/NativeComponents/common";
import { connect } from "react-redux";

import { PhoneBadge } from "./ContactabilityColumnItem";

class PhoneNumberColumnItem extends PureComponent {

  state = {
    showScrubTooltip: false,
    tooltipAnchorRect: null
  };

  handleTooltipEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState({
      showScrubTooltip: true,
      tooltipAnchorRect: rect
    });
  };

  handleTooltipLeave = () => {
    this.setState({
      showScrubTooltip: false,
      tooltipAnchorRect: null
    });
  };

  renderContactability() {
    const { property, user, dark_mode } = this.props;

    const contactability = property?.contactability;
    if (!contactability) return <Copy>--</Copy>;

    const scrub_dnc =
      user?.workspace_settings?.should_scrub_dnc_phone_numbers
        ? true
        : user?.user_settings?.dialer_settings?.scrub_dnc ?? true;

    const totalPhones = contactability.phone_count || 0;
    const dialablePhones = contactability.dialable_phone_count || 0;

    if (!totalPhones && !dialablePhones) {
      return <Copy>--</Copy>;
    }

    return (
      <PhoneBadge
        phone_count={totalPhones}
        dialable_phone_count={dialablePhones}
        scrub_dnc={scrub_dnc}
        dark_mode={dark_mode}
        showTooltip={this.state.showScrubTooltip}
        onTooltipEnter={this.handleTooltipEnter}
        onTooltipLeave={this.handleTooltipLeave}
        anchorRect={this.state.tooltipAnchorRect}
      />
    );
  }


  render() {
    const { row_height } = this.props;

    return (
      <Wrapper
        className="deal-hover-preview"
        style={{
          padding: 10,
          height: row_height,
          position: "relative"
        }}
      >
        <Wrapper
          style={{
            flex: 1,
            alignItems: "flex-start",
            justifyContent: "center"
          }}
        >
          {this.renderContactability()}
        </Wrapper>
      </Wrapper>
    );
  }
}

/* ---------------- REDUX CONNECT ---------------- */

const mapStateToProps = ({ settings }) => ({
  dark_mode: settings?.dark_mode
});

export default connect(mapStateToProps)(PhoneNumberColumnItem);
